import { Branding, useStateManager } from "@bcm-dev/bcms-vite";
import { CustomAccountSelect } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import { Account } from "model";
import React from 'react';
import "./styles.css";

/**
 * @function MobileMultiWireTable
 * @return {React.Component}
 * @exported true
 * @description The mobile view of the multi wire table
 */

export default function MobileMultiWireTable(props) {
  const { onChange } = useStateManager();
  const wire = props.wire ?? {};
  const payeeType = wire.payee.payeeType.charAt(0).toUpperCase() + wire.payee.payeeType.slice(1);

  return(
    <FormContainer className="mobile-multi-wire-table">
      <FormRowView>
        <b>{ wire.payee.nickname }</b>
      </FormRowView>
      <FormRowView>
        <p>Payee Name: <b>{ wire.payee.name }</b></p>
      </FormRowView>
      <FormRowView>
        <p>Notify Payee: <b>No</b></p>
      </FormRowView>
      <FormRowView>
        <p>Type: <b>{ payeeType }</b></p>
      </FormRowView>
      <FormRowView text="Wire Date:">
        <DateSelect value={ wire.date } onChange={ onChange("date", wire) } />
      </FormRowView>
      <FormRowView text="Account:">
        <CustomAccountSelect value={ Account.initByType(wire.fundingAccount.id) } accounts={ Account.initAllAsset() } onChange={ onChange("fundingAccount", wire) } />
      </FormRowView>
      <FormRowView text="Amount:">
        <UIAmountInput value={ wire.amount.amount === "" ? undefined : wire.amount.format({style:"decimal"}) } onBlur={ onChange("amount", wire) } />
      </FormRowView>
      <FormRowView>
        <p><span className="last">Last: <b>N/A</b></span><span className="scheduled">Scheduled: <b>N/A</b></span></p>
      </FormRowView>
      <Branding id="memo_abi22" value="true">
        <FormRowView text="Memo:">
          <UITextInput value={ wire.memo } onBlur={ onChange("memo", wire) } />
        </FormRowView>
      </Branding>
      <Branding id="beneficiaryref_abi22" value="true">
        <FormRowView text="Beneficiary Reference:">
          <UITextInput value={ wire.memo } onBlur={ onChange("memo", wire) } />
        </FormRowView>
      </Branding>

      <Branding id="messagetobeneficiary_abi22" value="true">
        <FormRowView className="message-to-beneficiary" text="Message to Beneficiary:">
          <UITextInput value={ wire.messageToBeneficiary1 } onBlur={ onChange("messageToBeneficiary1", wire) } />
        </FormRowView>
        <FormRowView className="message-to-beneficiary">
          <UITextInput value={ wire.messageToBeneficiary2 } onBlur={ onChange("messageToBeneficiary2", wire) } />
        </FormRowView>
        <FormRowView className="message-to-beneficiary">
          <UITextInput value={ wire.messageToBeneficiary3 } onBlur={ onChange("messageToBeneficiary3", wire) } />
        </FormRowView>
        <FormRowView className="message-to-beneficiary">
          <UITextInput value={ wire.messageToBeneficiary4 } onBlur={ onChange("messageToBeneficiary4", wire) } />
        </FormRowView>
      </Branding>

    </FormContainer>
  );
}